import { useTRPC } from "../../../../trpc/client";
import { useQueryClient, useMutation } from "@tanstack/react-query";

export function useSetCancelledPaymentActivation(
  onSuccess: (active: boolean) => void,
  onError: (error: unknown) => void
) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...trpc.invoices.setCancelledPaymentActivation.mutationOptions(),
    onSuccess: (_, { active }) => {
      queryClient.invalidateQueries({
        queryKey: trpc.invoices.list.queryKey(),
      });
      onSuccess(active);
    },
    onError,
  });

  return {
    setCancelledPaymentActivation: mutation.mutate,
    isPending: mutation.isPending,
  };
}
